<template>
  <div>
    <button class="btn btn-info m-2" @click="goBack">Back</button>
    <card class="card" title="Add terminal">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Terminal Id"
                placeholder="Terminal Id"
                v-model="terminal.terminalId"
                required
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Serial Number"
                placeholder="Serial No"
                v-model="terminal.serialNo"
                required
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Merchant Id"
                placeholder="Merchant Id"
                v-model="terminal.merchantId"
                required
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Terminal Id 1"
                placeholder="Terminal Id 1"
                v-model="terminal.terminalId1"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Terminal Id 2"
                placeholder="Terminal Id 2"
                v-model="terminal.terminalId2"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <label>Terminal Type</label>
              <multiselect
                v-model="selectedTerminalType"
                :custom-label="optionLabel3"
                track-by="key"
                :options="terminalTypes"
                :allow-empty="false"
                placeholder="Select a Terminal Type"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  {{ option.label }}
                </template>
              </multiselect>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>Institution Name</label>

              <select
                class="form-control op-border"
                id="rate-type"
                v-model="selectedInstitution"
                @change="getMerchants()"
                required
              >
                <option value="">Select Institution</option>
                <option
                  v-for="institution in allInstitutions"
                  :key="institution.id"
                  :value="institution._id"
                >
                  {{ institution.institutionName }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Merchant Name</label>

              <select
                class="form-control op-border"
                id="rate-type"
                v-model="selectedMerchant"
                required
              >
                <option value="">Select Merchant</option>
                <option
                  v-for="merchant in institutionMerchants"
                  :key="merchant._id"
                  :value="merchant._id"
                >
                  {{ merchant.merchantName }}
                </option>

                <option v-if="!institutionMerchants.length" disabled>
                  No merchants found under this institution
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Sales Officer</label>

              <v-select
                v-model="selectedSalesOfficer"
                :options="formattedSalesOfficers"
                :reduce="(officer) => officer._id"
                label="fullName"
                placeholder="Select Sales Officer"
                searchable
                style="border: none"
                required
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>State</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.state"
                required
                @change="fetchLgas()"
              >
                <option value="">State</option>
                <option v-for="st in utils.allStates" :key="st" :value="st">
                  {{ st }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Local Government</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.localGovernment"
                required
              >
                <option value="">Select Local Government</option>
                <option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
                  {{ lg.name }}
                </option>
              </select>
              <span v-if="utils.lgaLoading"> Fetching Lga's </span>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Add Terminal
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "../store/axios";

export default {
  components: {
    Multiselect,
    vSelect,
  },
  data() {
    return {
      terminal: {
        terminalId: "",
        terminalId1: "",
        terminalId2: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        country: "",
        state: "",
        localGovernment: "",
        terminalType: "",
        salesOfficerId: "",
        institutionName: "",
      },
      selectedMerchant: "",
      selectedAgent: "",
      selectedTerminalType: "",
      selectedSalesOfficer: "",
      selectedInstitution: "",
      terminalTypes: [
        { label: "T3 POS", key: "T3 POS" },
        { label: "CARD READER", key: "CARD READER" },
        { label: "MPOS", key: "MPOS" },
      ],
      allSalesOfficers: [],
      allInstitutions: [],
      institutionMerchants: [],
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),

    formattedSalesOfficers() {
      return this.allSalesOfficers.map((o) => ({
        ...o,
        fullName: `${o.firstName} ${o.lastName || ""}`.trim(),
      }));
    },
  },
  methods: {
    ...mapActions([
      "createPtspTerminal",
      "getMerchants",
      "getStates",
      "getLgas",
      "getCountries",
      "getAllMerchantAgents",
    ]),
    goBack() {
      window.history.back();
    },

    isValid(values) {
      let missingFields = [];
      if (!values.terminalId) {
        missingFields.push("Terminal Id");
      }

      if (!values.serialNo) {
        missingFields.push("Serial Number");
      }
      if (!values.selectedMerchant) {
        missingFields.push("Merchant Name");
      }
      if (!values.merchantId) {
        missingFields.push("Merchant Id");
      }

      if (!values.selectedTerminalType) {
        missingFields.push("Terminal Type");
      }
      if (!values.selectedInstitution) {
        missingFields.push("Institution");
      }

      if (!values.state) {
        missingFields.push("State");
      }
      if (!values.localGovernment) {
        missingFields.push("Local Government");
      }

      if (missingFields.length > 0) {
        this.$toast.error(
          `Please fill in all the following fields: ${missingFields.join(
            ", ",
          )}`,
        );
        return false;
      }

      return true;
    },

    submit() {
      this.terminal.selectedInstitution = this.selectedInstitution;
      this.terminal.selectedTerminalType = this.selectedTerminalType;
      this.terminal.selectedMerchant = this.selectedMerchant;

      if (!this.isValid(this.terminal)) return;

      if (this.selectedMerchant !== "") {
        this.terminal.tmsMerchantId = this.selectedMerchant;
      }
      if (this.selectedAgent !== "") {
        this.terminal.tmsAgentId = this.selectedAgent._id;
      }
      if (this.selectedSalesOfficer !== "") {
        this.terminal.salesOfficerId = this.selectedSalesOfficer;
      }
      if (this.selectedTerminalType !== "") {
        this.terminal.terminalType = this.selectedTerminalType.label;
      }
      if (this.selectedInstitution !== "") {
        this.terminal.institutionName = this.selectedInstitution;
      }
      this.createPtspTerminal(this.terminal);
    },

    optionLabel3({ label }) {
      return `${label}`;
    },
    fetchLgas() {
      this.terminal.lga = "";
      this.getLgas(this.terminal.state);
    },
    getAgents() {
      // console.log(this.selectedMerchant)
      this.getAllMerchantAgents({ merchantId: this.selectedMerchant._id });
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
        console.log("error", err);
      }
    },

    async getInstitutions() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
        );

        const institutions = res.data.institutions.docs;
        this.allInstitutions = institutions;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/institution/${this.selectedInstitution}/merchants`,
        );

        this.institutionMerchants = res.data.data;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },
  },

  async mounted() {
    this.getMerchants();
    // this.getCountries();
    this.getStates();
    this.getSalesOfficers();
    this.getInstitutions();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
